<template>
    <div class="PendingNotificationItem row">
        <span class='StatusIcon col-2'>
            <!--<NotificationSuccess v-if="type=='success'" class='SuccessIcon Icon'>{{type}}</NotificationSuccess>
            <NotificationError class='ErrorIcon Icon' v-if="type.includes('Error:')"></NotificationError>
            <MissingStatus v-if="type==null">No Notificiation</MissingStatus>-->
            <InProgressNotification/>
        </span>
        <div class='NotificationText col-6 text-left' >
            <p><a :href='link'>{{name}}</a></p>
            <p :class='type'>{{type}}</p>
            <p><span>{{displayTime}}</span></p>
        </div>
        <div class="NotificationImg col-2 text-right">
            <div class='ImgWrap'>
                <img :src='productImage'/>
            </div>
        </div>
        <button class='CloseNotification col-1' @click="$emit('remove-notification', notificationObject)" >
            &times;
        </button>
    </div>
</template>
<script>
    import MissingStatus from '../../../icons/MissingStatus.vue';
    import NotificationSuccess from '../../../icons/NotificationSuccess.vue';
    import NotificationError from '../../../icons/NotificationError.vue';
    import InProgressNotification from '../../../icons/InProgressNotification.vue';
    export default{
        name: 'PendingNotificationItem',
        props:['name', 'link', 'time', 'type', 'notificationObject'],
        components:{
            MissingStatus,
            NotificationSuccess,
            NotificationError,
            InProgressNotification
        },
        data(){
            return{
                timeStarted: Date.now(),
                dateToday: new Date().getDate(),
                productImage: this.$props.notificationObject.product.img || this.$props.notificationObject.product.image,
                interval: null,
                displayTime: ''
            }
        },
        computed:{
            elapsedTime(){
                return Math.floor((this.timeStarted - this.$props.time) / 1000)
            },
            notificationDate(){
                return new Date(this.$props.time).getDate()
            },
            notificationTime(){
                return new Date(this.$props.time).toLocaleTimeString()
            },
            notificationMonth(){
                switch(new Date(this.$props.time).getMonth()){
                     case 0: return 'Jan'
                    case 1: return 'Feb'
                    case 2: return 'Mar'
                    case 3: return 'Apr'
                    case 4: return 'May'
                    case 5: return 'June'
                    case 6: return 'July'
                    case 7: return 'Aug'
                    case 8: return 'Sept'
                    case 9: return 'Oct'
                    case 10: return 'Nov'
                    case 11: return 'Dec'
                }
            }
        },
        created(){
            this.showDisplayTime();
            this.interval = setInterval(this.showDisplayTime, 30000);
        },
        beforeDestroy(){
            clearInterval(this.interval);
        },
        methods:{
            showDisplayTime(){
                this.timeStarted = Date.now();
                if(this.elapsedTime < 2){
                    this.displayTime = "Just Now"
                }else if(this.elapsedTime < 60){
                    this.displayTime = " less than a minute ago";
                }else if(this.elapsedTime < 120){
                    this.displayTime = Math.floor(this.elapsedTime / 60) + " minute ago";
                }else if(this.elapsedTime < 3600){
                    this.displayTime =  Math.floor(this.elapsedTime / 60) + " minutes ago";
                }else if(this.elapsedTime < 7200){
                    this.displayTime = "1 hour ago"
                }else if((this.dateToday == this.notificationDate) && (this.elapsedTime < 86400)){
                    this.displayTime = Math.floor(this.elapsedTime / 3600) + " hours ago"
                }else if(this.dateToday != this.notificationDate){
                    this.displayTime = this.notificationMonth+" "+this.notificationDate+" at "+this.notificationTime
                }else{
                    this.displayTime = this.notificationMonth+" "+this.notificationDate+" at "+this.notificationTime
                }
            }
        }
    }
</script>